export * from './lib/shared-main-menu-notification.module';
export * from './lib/notification/notification.component';
